var customer = {
  state: {
    partyId: '',
    partyName: ''
  },
  mutations: {
    SET_CUSTOMER: function SET_CUSTOMER(state, row) {
      state.partyId = row.partyId;
      state.partyName = row.partyName;
    }
  },
  actions: {
    SetCustomer: function SetCustomer(_ref, row) {
      var commit = _ref.commit;
      commit('SET_CUSTOMER', row);
    },
    DeleteCustomer: function DeleteCustomer(_ref2) {
      var commit = _ref2.commit;
      commit('SET_CUSTOMER', '', '');
    }
  }
};
export default customer;